import angular from 'angular';

import get from 'lodash/get';

angular.module('admin-angucomplete', []).directive('adminAngucomplete', ($timeout, $sce) => {
  return {
    restrict: 'EA',
    scope: {
      id: '@id',
      placeholder: '@placeholder',
      minLengthUser: '@minLength',
      userPause: '@pause',
      filterIds: '=filterIds',
      filterField: '@filterField',
      titleField: '@titleField',
      descriptionField: '@descriptionField',
      additionalField: '@additionalField',
      additionalTitle: '@additionalTitle',
      matchClass: '@matchClass',
      keyField: '@keyField',
      searchFn: '&searchFn',
      nextFn: '&nextFn',
      blurFn: '&blurFn',
      onSelect: '&onSelect',
      onProcessing: '&onProcessing',
    },

    template:
      '<div class="angucomplete-holder" id="{{id}}">' +
      '<div class="angucomplete-input">' +
      '<input id="{{id}}_value" ng-model="searchStr" ng-blur="blurFn()" ng-click="clearInput()" type="text" placeholder="{{placeholder}}" />' +
      '<span class="fa fa-search angucomplete-search-icon"></span>' +
      '</div>' +
      '<div id="{{id}}_dropdown" class="angucomplete-dropdown" ng-if="showDropdown">' +
      '<div class="admin-angucomplete-row angucomplete-row" ng-repeat="result in results" ng-mousedown="selectResult(result)" ng-mouseover="hoverRow()" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}">' +
      '<div style="max-width: 80%">' +
      '<div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div>' +
      '<div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div>' +
      '<div class="angucomplete-description" ng-if="result.description" ng-bind-html="result.description"></div>' +
      '</div>' +
      '<div class="angucomplete-more" ng-if="result.more">{{ additionalTitle }}: {{ result.more }}</div>' +
      '</div>' +
      '<div class="angucomplete-searching" ng-show="searching">Searching...</div>' +
      '<div class="angucomplete-searching" ng-show="!searching && (!results || !results.length)">' +
      'No matching results found.' +
      '</div>' +
      '</div>' +
      '</div>',
    link: ($scope, elem) => {
      $scope.searchStr = null;
      $scope.showDropdown = false;
      $scope.minLength = 3;
      $scope.pause = 500;
      $scope.processing = false;
      $scope.nextPage = null;

      if ($scope.minLengthUser) {
        $scope.minLength = $scope.minLengthUser;
      }

      if ($scope.userPause) {
        $scope.pause = $scope.userPause;
      }

      $scope.processResults = (res, str) => {
        $scope.processing = true;

        if (res) {
          const { meta } = res;
          if (meta && meta.next) {
            $scope.nextPage = meta.next;
          } else {
            $scope.nextPage = null;
          }
          res = res[$scope.keyField];
        }

        if ($scope.filterIds && $scope.filterIds.length > 0) {
          res = res.filter(
            (item) => !$scope.filterIds.includes(get(item, $scope.filterField || 'id')),
          );
        }

        if (res && res.length > 0) {
          const titleFields = $scope.titleField ? $scope.titleField.split(',') : [];
          const descriptionFields = $scope.descriptionField
            ? $scope.descriptionField.split(',')
            : [];
          for (let i = 0; i < res.length; i++) {
            const titleCode = [];

            for (let j = 0; j < titleFields.length; j++) {
              titleCode.push(get(res[i], titleFields[j]));
            }

            let text = titleCode.join(' ');
            let description = '';
            let moreText = $scope.additionalField ? get(res[i], $scope.additionalField) : '';

            if ($scope.descriptionField === 'address_information') {
              const address = get(res[i], $scope.descriptionField);
              if (address['address_1']) {
                description += '<span>' + address['address_1'] + '<span><br />';
              }
              if (address['address_2']) {
                description += '<span>' + address['address_2'] + '<span><br />';
              }
              if (address['city'] && address['state'] && address['zip']) {
                description +=
                  '<span>' + `${address['city']}, ${address['state']} ${address['zip']}` + '<span>';
              }
            } else {
              const descriptionCode = [];
              for (let j = 0; j < descriptionFields.length; j++) {
                descriptionCode.push(get(res[i], descriptionFields[j]));
              }
              description = descriptionCode.join(' ');
            }

            if ($scope.matchClass) {
              const re = new RegExp(str, 'i');

              if (text.match(re)) {
                const textPart = text.match(re)[0];
                text = $sce.trustAsHtml(
                  text.replace(
                    textPart,
                    '<span class="' + $scope.matchClass + '">' + textPart + '</span>',
                  ),
                );
              }
            }

            $scope.results.push({
              title: text,
              description: description,
              more: moreText,
              originalObject: res[i],
            });
          }

          $scope.scrollList = $(elem).find('.angucomplete-dropdown');
          $scope.scrollMonitor();
          $scope.processing = false;
        }
      };

      $scope.scrollMonitor = () => {
        $scope.scrollList.scroll((e) => {
          const scroll = $scope.scrollList.scrollTop() + $scope.scrollList.outerHeight();
          const scrollHeight = $scope.scrollList[0] && $scope.scrollList[0].scrollHeight;
          if (
            $scope.nextFn &&
            $scope.nextPage &&
            scroll >= scrollHeight &&
            !$scope.searching &&
            !$scope.processing
          ) {
            $scope.searching = true;
            $scope.nextFn({ query: $scope.nextPage }).then((res) => {
              $timeout(() => {
                $scope.searching = false;
                $scope.processResults(res);
              });
            });
          }
        });
      };

      $scope.selectResult = (result) => {
        $scope.showDropdown = false;
        $scope.results = [];

        if ($scope.onSelect) {
          $scope.onSelect({ item: result.originalObject });
        }
      };

      $scope.clearInput = () => {
        if ($scope.showDropdown === false) {
          $scope.searchStr = null;
        }
      };

      $scope.searchTimerComplete = (str) => {
        if ($scope.searchFn) {
          $scope.searchFn({ query: str }).then((res) => {
            $timeout(() => {
              $scope.searching = false;
              $scope.processResults(res, str);
            });
          });
        }
      };

      $scope.keyPressed = (event) => {
        if (!(event.which === 13 || event.which === 40 || event.which === 38)) {
          if ($scope.searchStr && $scope.searchStr.length >= $scope.minLength) {
            $scope.showDropdown = true;
            $scope.currentIndex = -1;
            $scope.results = [];

            if ($scope.searchTimer) {
              $timeout.cancel($scope.searchTimer);
            }
            $scope.searching = true;
            $scope.searchTimer = $timeout(() => {
              $scope.searchTimerComplete($scope.searchStr);
            }, $scope.pause);
          }
        }
      };

      $scope.$watch('searchStr', () => {
        if (!$scope.searchStr) {
          $scope.results = [];
          $scope.showDropdown = false;
        }
      });

      $scope.$watch('showDropdown', () => {
        $scope.onProcessing({
          item: !$scope.showDropdown,
        });
      });

      $(document).on('click', (event) => {
        const autoElement = $('#' + $scope.id);
        const $target = $(event.target);

        if (
          autoElement !== event.target &&
          !$target.closest('#' + $scope.id).length &&
          !autoElement.has(event.target).length &&
          $scope.showDropdown === true
        ) {
          const e = document.getElementById($scope.id + '_value');

          if (e) {
            e.value = '';
            angular.element(e).triggerHandler('input');
          }
        }
      });

      const inputField = elem.find('input');
      inputField.on('keyup', $scope.keyPressed);

      elem.on('keyup', function (event) {
        if (event.which === 40) {
          if ($scope.results && $scope.currentIndex + 1 < $scope.results.length) {
            $scope.currentIndex++;
            event.preventDefault();
            event.stopPropagation();
          }
          $timeout(() => {});
        } else if (event.which === 38) {
          if ($scope.currentIndex >= 1) {
            $scope.currentIndex--;
            event.preventDefault();
            event.stopPropagation();
          }
          $timeout(() => {});
        } else if (event.which === 13) {
          if (
            $scope.results &&
            $scope.currentIndex >= 0 &&
            $scope.currentIndex < $scope.results.length
          ) {
            $scope.selectResult($scope.results[$scope.currentIndex]);
            event.preventDefault();
            event.stopPropagation();
          } else {
            $scope.results = [];
            event.preventDefault();
            event.stopPropagation();
          }
          $timeout(() => {});
        } else if (event.which === 27 || event.which === 9) {
          $scope.results = [];
          $scope.showDropdown = false;
          $timeout(() => {});
        }
        return false;
      });
    },
  };
});
